import euro from "@/util/euro";

/**
 * Berechnet den Monatspreis für einen Tarif, beachtet dabei die Preisoptionen.
 *
 * @param tarif Objekt mit den Tarif-Einstellungen
 * @param tarif_preis Errechnete Grundpreis für den Tarif
 * @param preisoptionen Ausgewählte Preisoptionen
 * @param jvl Rabatt für Jahresvorauszahlung
 * @returns currency-object kann mit .format() als EUR formatiert werden
 */
export function berechneMonatspreis(tarif, tarif_preis, preisoptionen, jvl) {
  let preis = euro(tarif_preis);
  // console.log(preisoptionen, 'preisoptionen');

  if (tarif && (tarif.preisoptionen || tarif.tarif_preisoptionen)) {
    (tarif.preisoptionen || tarif.tarif_preisoptionen).forEach(gruppe => {
      if (preisoptionen && preisoptionen[gruppe.uid]) {
        gruppe.positionen.forEach(position => {
          if (position.betrag === preisoptionen[gruppe.uid]) {
          // console.log(position, 'position');
          if (position.einheit_und_berechnung === 1) {
            // Preis pro Monat
            const betragInEuro = position.betrag / 100;
            preis = preis.add(betragInEuro);
          } else if (position.einheit_und_berechnung === 2) {
            // Preis pro kWh
            const betragInEuro = tarif.preiseMitRabatt.consumptionPerYear * position.betrag / 100 / 12;
            preis = preis.add(betragInEuro);
          }
          }
        });
      }
      // if (preisoptionen && preisoptionen[gruppe.uid]) {
      //   const value = preisoptionen[gruppe.uid];
      //   // TODO: Hinzufügen von anderen Einheiten (zum Beispiel Prozent)
      //   if (Array.isArray(value)) {
      //     console.log(value, 'value');
      //     value.forEach(selectedValue => {
      //       preis = preis.add(selectedValue);
      //     })
      //   } else {
      //     preis = preis.add(value);
      //   }
      // }
    });
  }
  if (jvl > 0) {
    const rabatt = (100 - jvl) / 100;
    preis = preis.multiply(rabatt);
  }
  return preis;
}

/**
 * Berechnet den Jahrespreis für einen Tarif, beachtet dabei die Preisoptionen.
 *
 * @param tarif Objekt mit den Tarif-Einstellungen
 * @param tarif_preis Errechnete Grundpreis für den Tarif
 * @param preisoptionen Ausgewählte Preisoptionen
 * @param jvl Rabatt für Jahresvorauszahlung
 * @returns currency-object kann mit .format() als EUR formatiert werden
 */
export function berechneJahrespreis(tarif, tarif_preis, preisoptionen, jvl) {
  let preis = euro(tarif_preis);
  if (tarif && (tarif.preisoptionen || tarif.tarif_preisoptionen)) {
    (tarif.preisoptionen || tarif.tarif_preisoptionen).forEach(gruppe => {
      if (preisoptionen && preisoptionen[gruppe.uid]) {
        gruppe.positionen.forEach(position => {
          if (position.betrag === preisoptionen[gruppe.uid]) {
            if (position.einheit_und_berechnung === 1) {
              // Preis pro Monat
              const betragInEuro = position.betrag / 100;
              preis = preis.add(betragInEuro);
            } else if (position.einheit_und_berechnung === 2) {
              // Preis pro kWh
              const betragInEuro = tarif.preiseMitRabatt.consumptionPerYear * position.betrag / 100 / 12;
              preis = preis.add(betragInEuro);
            }
          }
        });
      }
      // if (preisoptionen && preisoptionen[gruppe.uid]) {
      //   const value = preisoptionen[gruppe.uid];
      //   // TODO: Hinzufügen von anderen Einheiten (zum Beispiel Prozent)
      //   if (Array.isArray(value)) {
      //     value.forEach(selectedValue => {
      //       preis = preis.add(selectedValue);
      //     })
      //   } else {
      //     preis = preis.add(value);
      //   }
      // }
    });
  }
  if (jvl > 0) {
    const rabatt = (100 - jvl) / 100;
    preis = preis.multiply(rabatt);
  }
  return preis.multiply(12);
}

/**
 * Berechnet den Monatsabschlag für einen Tarif, beachtet dabei die Preisoptionen.
 * Für InBo werden 11 Abschläge gezahlt, für ExBo 12
 * Am Ende wird kaufmännisch gerundet
 *
 * @param tarif Objekt mit den Tarif-Einstellungen
 * @param tarif_preis Errechnete Grundpreis für den Tarif
 * @param preisoptionen Ausgewählte Preisoptionen
 * @param type InBo = 1, ExBo = 2
 * @param jvl Rabatt für Jahresvorauszahlung
 * @returns currency-object kann mit .format() als EUR formatiert werden
 */
export function berechneMonatsabschlag(tarif, tarif_preis, preisoptionen, type, jvl) {
  let preis = euro(tarif_preis);
  if (tarif && (tarif.preisoptionen || tarif.tarif_preisoptionen)) {
    (tarif.preisoptionen || tarif.tarif_preisoptionen).forEach(gruppe => {
      if (preisoptionen && preisoptionen[gruppe.uid]) {
        gruppe.positionen.forEach(position => {
          if (position.betrag === preisoptionen[gruppe.uid]) {
            if (position.einheit_und_berechnung === 1) {
              // Preis pro Monat
              const betragInEuro = position.betrag / 100;
              preis = preis.add(betragInEuro);
            } else if (position.einheit_und_berechnung === 2) {
              // Preis pro kWh
              const betragInEuro = tarif.preiseMitRabatt.consumptionPerYear * position.betrag / 100 / 12;
              preis = preis.add(betragInEuro);
            }
          }
        });
      }
      // if (preisoptionen && preisoptionen[gruppe.uid]) {
      //   const value = preisoptionen[gruppe.uid];
      //   // TODO: Hinzufügen von anderen Einheiten (zum Beispiel Prozent)
      //   if (Array.isArray(value)) {
      //     value.forEach(selectedValue => {
      //       preis = preis.add(selectedValue);
      //     })
      //   } else {
      //     preis = preis.add(value);
      //   }
      // }
    });
  }
  if (jvl > 0) {
    const rabatt = (100 - jvl) / 100;
   preis = preis.multiply(rabatt);
  }
  if (type === 1) {
    preis = (preis.multiply(12)).divide(11);
  }
  // preis = euro(Math.round(preis));
  // LV 24.06.2025 Immer aufrunden statt kaufmännisch
  // https://taiga.unternehmen.online/project/stadtwerke-bochum-website/issue/312
  preis = euro(Math.ceil(preis));

  return preis;
}

/**
 * Berechnet / formatiert den Grundversorgerpreis
 */
export function berechneGvsPreis(tarif_preis){
  let preis = euro(tarif_preis);

  return preis;
}

/**
 * Berechnet die Differenz zwischen dem Grundversorger- und SWBO-Preis
 */
export function diffGvsSwboPreis(gvspreis, swbopreis){
  let preis = euro(gvspreis);
  preis = preis.subtract(swbopreis);

  return preis;
}
